import Table from "../../../components/table/table";

const AttendanceTable = ({ t, setOpen }) => {
  const handleClick = () => {
    setOpen(true);
  };
  const employees = [
    {
      id: 1,
      name: "هشام المدير هشام",
      department: "تكنولوجيا المعلومات",
      date: "05/06/2023",
      timeIn: "08:02",
      timeOut: "17:05",
      status: "present",
    },
    {
      id: 2,
      name: "سارة عبدالله",
      department: "المبيعات",
      date: "05/06/2023",
      timeIn: "08:10",
      timeOut: "17:00",
      status: "present",
    },
    {
      id: 3,
      name: "هشام المدير علي",
      department: "المالية",
      date: "05/06/2023",
      timeIn: "-",
      timeOut: "-",
      status: "absent",
    },
    {
      id: 4,
      name: "هشام المدير علي",
      department: "المالية",
      date: "05/06/2023",
      timeIn: "-",
      timeOut: "-",
      status: "absent",
    },
    {
      id: 5,
      name: "سارة عبدالله",
      department: "المبيعات",
      date: "05/06/2023",
      timeIn: "08:10",
      timeOut: "17:00",
      status: "present",
    },
    {
      id: 6,
      name: "سارة عبدالله",
      department: "المبيعات",
      date: "05/06/2023",
      timeIn: "08:10",
      timeOut: "17:00",
      status: "present",
    },
  ];

  const tableHead = [
    {
      header: "id",
      accessorKey: "id",
    },
    {
      header: t("name"),
      accessorKey: "name",
    },
    {
      header: t("department"),
      accessorKey: "department",
    },
    {
      header: t("date"),
      accessorKey: "date",
    },
    {
      header: t("attendanceTime"),
      accessorKey: "attendanceTime",
    },
    {
      header: t("leaveTime"),
      accessorKey: "leaveTime",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
  ];
  const tableData = employees.map((m, i) => {
    const statusColor = m.status === "present" ? "#E6F4EF" : "#F4ECE6";
    const statusTextColor = m.status === "present" ? "#11A849" : "#C42E27";
    const status = (
      <span
        style={{ backgroundColor: statusColor, color: statusTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {t(m.status)}
      </span>
    );

    return {
      id: m.id,
      name: m.name,
      department: m.department,
      date: m.date,
      attendanceTime: m.timeIn,
      leaveTime: m.timeOut,
      status,
    };
  });
  return (
    <Table
      onRowClick={handleClick}
      TableData={tableData}
      TableHead={tableHead}
      trStyle="cursor-pointer"
    />
  );
};

export default AttendanceTable;
